<template>
    <table ref="table"
        class="scrolling"
        :class="{ scrolly: scrollVertical, scrollx: scrollHorizontal }"
        :style="tableStyle"
        >
        <thead name="thead" ref="thead"
            :class="{ scrollsync: syncHeaderScroll }"
            :style="syncHeaderScroll && scrollVertical ? stubScrollbarStyle : ''"
            ><slot name="thead"/></thead>
        <tbody name="tbody" ref="tbody"
            @scroll.passive="updateSyncedScroll"><slot name="tbody"/></tbody>
        <tfoot name="tfoot" ref="tfoot"
            v-if="includeFooter"
            :class="{ scrollsync: syncFooterScroll }"
            :style="syncFooterScroll && scrollVertical ? stubScrollbarStyle : ''"
            ><slot name="tfoot"/></tfoot>
    </table>
</template>
<script>
export default {
    name: "ScrollingTable",
    props: {
        deadAreaColor: { type: String, required: false, default: "#CCC" },
        includeFooter: { type: Boolean, required: false, default: false },
        syncHeaderScroll: { type: Boolean, required: false, default: true },
        syncFooterScroll: { type: Boolean, required: false, default: true },
        scrollHorizontal: { type: Boolean, required: false, default: true },
        scrollVertical: { type: Boolean, required: false, default: true },
    },
    computed: {
        tableStyle() {
            return `background-color: ${this.deadAreaColor};`
        },
        stubScrollbarStyle() {
            return `background-color: ${this.deadAreaColor};
                scrollbar-base-color: ${this.deadAreaColor};
                scrollbar-face-color: ${this.deadAreaColor};
                scrollbar-highlight-color: ${this.deadAreaColor};
                scrollbar-track-color: ${this.deadAreaColor};
                scrollbar-arrow-color: ${this.deadAreaColor};
                scrollbar-shadow-color: ${this.deadAreaColor};
                scrollbar-darkshadow-color: ${this.deadAreaColor};`
        },
    },
    mounted: function() {
        this.updateSyncedScroll()
    },
    methods: {
        updateSyncedScroll() {
            const b = this.$refs.tbody
            const l = b.scrollLeft
            if (this.scrollHorizontal) {
                if (this.syncHeaderScroll) {
                    const h = this.$refs.thead
                    if (h.scrollLeft !== l) {
                        h.scrollLeft = l
                    }
                }
                if (this.includeFooter && this.syncFooterScroll) {
                    const f = this.$refs.tfoot
                    if (f.scrollLeft !== l) {
                        f.scrollLeft = l
                    }
                }
            }
            this.$emit("scroll", b.scrollTop, l, b.scrollHeight, b.scrollWidth)
        },
    },
}
</script>
